import React from "react";
import {Box} from "@mantine/core";
import {IGroupStep, IInstructionStep} from "@/protocols/types/protocol.ts";
import {IGroupStepDefinition, IInstructionStepDefinition} from "@/protocols/types/protocolDefinitions.ts";
import '@mdxeditor/editor/style.css'
import {MarkdownEditor} from "@/common/components/MarkdownEditor";
import {DeepPartial} from "@/utils/types/DeepPartial";

import {TWorkflow} from "../StepView";

/** Union type for Instruction steps (both execution and planning modes) */
type InstructionStep = IInstructionStep | IInstructionStepDefinition;

export interface GroupStepViewProps {
    step: IGroupStepDefinition | IGroupStep;
    onChange: (updates: DeepPartial<InstructionStep>) => void;
    workflow?: TWorkflow;
}

/**
 * View component for instruction steps.
 * - Planning mode: Renders MarkdownEditor in editable mode
 * - Execution mode: Renders MarkdownEditor in readonly mode
 */
export const GroupStepView: React.FC<GroupStepViewProps> = ({
    step,
    onChange,
    workflow = "session",
}) => {
    const isReview = workflow === "review" || workflow === "review_edit";

    const handleInstructionsChange = (value: string) => {
        onChange({
            instructions: value
        });
    };

    return (
        <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
            {(!isReview || (isReview && step.instructions)) ?
                <Box style={{
                    gridColumn: "1/-1",
                }}>
                    <MarkdownEditor
                        editingMode={workflow === "planning" || workflow === "review_edit"
                            ? "full"
                            : workflow === "session"
                                ? "checkboxes"
                                : "none"}
                        markdown={step.instructions || ""}
                        onChange={handleInstructionsChange}
                        mdDataTestId="input-instructions"
                    />
                </Box> : <></>
            }
        </div>
    );
};